$(document).ready(function() {
    setupTooltips();
    setupRecorder();

    $('.questionariocollapse').click(function(e) {
        $(this).text($(this).text() == 'continua' ? 'chiudi' : 'continua');
    });

    // Gestione Cookies prenotazioni e google ads
    const qp = getQueryParams();

    //todo qui c'è da fixare il problema delle query params
    if(qp.hasOwnProperty('src')) {
        //questo è fondamentale altrimenti non si può fare redirect o prentazione
        setCookie('pren_src', qp.src, 30, '/', 'o');
    }

    if(qp.hasOwnProperty('gads')) {
        curScript = "setCookie('gads', '" + qp.gads + "',30,'/', 'm');";
        if(cookieObj) {
            cookieObj.injectScript(curScript, 'm');
        }
    }

    if(qp.hasOwnProperty('fads')) {
        curScript = "setCookie('fads', '" + qp.fads + "',30,'/', 'm');";
        if(cookieObj) {
            cookieObj.injectScript(curScript, 'm');
        }
    }

    if(qp.hasOwnProperty('bads')) {
        curScript = "setCookie('bads', '" + qp.bads + "',30,'/', 'm');";
        if(cookieObj) {
            cookieObj.injectScript(curScript, 'm');
        }
    }

    $('#ajax-modal').on('show.bs.modal', async (e) => {

        var button = $(e.relatedTarget);
        var modal = $(e.delegateTarget);

        modal.find('.modal-dialog').removeClass('modal-lg');
        modal.attr('data-html', '');

        if (button && button.data("remote")) {
            if (button.data('modal-lg')) {
                modal.find('.modal-dialog').addClass('modal-lg');
            }
            let onResult = await httpRequest(button.data("remote"))
            if (button.data('html')) {
                modal.attr('data-html', button.data('html'));
                onResult = onResult.data[button.data('html')];
            }

            modal.find('.modal-body').html(onResult);
        }

    });

    $('[data-role="scroll"]').on('click', function(e) {
        e.preventDefault();
        const target = $(e.delegateTarget).data('target');

        if (!$(target).length) return;
        const offsetTop = $(e.delegateTarget).data('offset-top') || 0;


        $('html, body').animate({
            scrollTop: $(target).offset().top - offsetTop
        }, 1000);
    });

    if($('[data-request-modal-onload="1"]:first').length) {
        $('[data-request-modal-onload="1"]:first').modal('show');
    }

    $('.continua').on('click', function() {
        $(this).hide();
        $(this).closest('.cont-wrapper').find('.continuazione').fadeIn(300).addClass('d-inline');
    });

    $('.cont-close').on('click', function() {
        $(this).closest('.continuazione').fadeOut(300,function() {
            $(this).removeClass('d-inline').closest('.cont-wrapper').find('.continua').fadeIn(300);
        });
    });

    $(document).on('click','*[data-toggle="lightbox"]',function(event) {
        event.preventDefault();
        return $(this).ekkoLightbox();
    });

    $('.btn-mostra-scondi').on('click', function(e) {
        e.preventDefault();
        var btn = $(this);
        if (!btn.data('target')) {
            return false;
        }

        var target = $(this).data('target');
        if (!$(target).length) {
            return false;
        }

        $(target).find('.nascosto').slideToggle(400, function() {

        });

        setTimeout(function() {
            btn.attr('data-expanded' , btn.attr('data-expanded') == 'true' ? 'false' : 'true');
            if (btn.attr('data-expanded') == 'false') {
                var targetClose = btn.data('after-close');
                if (targetClose && $(targetClose).length) {
                    $('html, body').animate({scrollTop: $(targetClose).offset().top}, 1000);
                }
            }
        }, 400);
    });

    $('.btn-nearby').on('click',function() {
        var targetModal = $(this).data('target-modal');
        redirect_nearby($(this).data('type'), $(this).data('id'), targetModal);
    });

    var stickyHeading = $('.sticky-heading').first();

    if (stickyHeading.length) {
        $(document).on('scroll', function(){
            var scrollTop = $(document).scrollTop();

            if(scrollTop == stickyHeading.position().top && !stickyHeading.hasClass('sticky-heading-sticked')) {
                stickyHeading.addClass('sticky-heading-sticked');
                return;
            }

            if(scrollTop < stickyHeading.position().top && stickyHeading.hasClass('sticky-heading-sticked')) {
                stickyHeading.removeClass('sticky-heading-sticked');
            }
        });
    }

    if($('.page-malattia')) {
        var key = $('#articolo-wrapper').data('key');
        if(key) {
            httpRequest(api_url + 'frontend/malattia/views/' + key, {}, {showLoader: false})
        }
    }

    if($('.page-clinica').length || $('.page-medico').length) {
        $('#show-other-reviews').on('click', function(e) {
            let curPage = $(e.delegateTarget).data('current-page');
            const totalPages = $(e.delegateTarget).data('total-pages');
            curPage++;
            $(e.target).closest('.wrapper-reviews').find('[data-page="' + curPage + '"]').slideDown();

            if (curPage >= totalPages) {
                $(e.target).hide();
            }

            $(e.delegateTarget).data('current-page', curPage);
        });
        
        var baseAppSticky = $('.page-clinica').length ? $('#baseAppSticky') : $('#medico-box-orari');
        var mapHeight = $('.page-clinica').length ? $('#map-container').height() : 0;
        var prestHeight = $('.prest-warning').first().height() || 0;

        baseAppSticky.on('change', function() {
            var curHeight = $(this).height() - mapHeight - prestHeight;

            if (curHeight > $(window).height()) {
                $(this).removeClass('sticky-top').addClass('position-relative').css('top', '0px');
                return;
            }
            $(this).addClass('sticky-top').removeClass('position-relative').removeAttr('style');
        });
        $(window).on('scroll', function() {
            baseAppSticky.trigger('change');
        });
    }
});
